export const FeatureFlag = {
  DEPOSIT_CRYPTO_ENABLED: 'deposit.crypto.enabled',
  GAMIFICATION_ENABLED: 'gamification.enabled',
  MARKET_CA_ENABLED: 'market.ca.enabled',
} as const;

export type FeatureFlagName = (typeof FeatureFlag)[keyof typeof FeatureFlag];
